(() => {
  const root = document.documentElement;
  let frame, currentRow, offsetX = 0, offsetY = 0, chatRetries = 0;
  const activator = (scope) => {
    if (!scope) return null;
    const part = scope.querySelector('[part~="activator"]');
    if (part) return part;
    for (const element of scope.querySelectorAll('*')) {
      if (element.shadowRoot) { const found = activator(element.shadowRoot); if (found) return found; }
    }
    return null;
  };
  const update = () => {
    frame = null;
    const drawer = document.querySelector('cart-drawer[open]');
    const scope = drawer || (document.body.classList.contains('cart-template') ? document : null);
    const sticky = !scope ? document.querySelector('.sticky-atc-bar--show') : null;
    const button = scope?.querySelector('[name="checkout"]') || sticky?.querySelector('[name="add"]');
    const row = scope ? (button?.closest('.drawer__footer-buttons') || button) : null;
    if (currentRow !== row) {
      currentRow?.removeAttribute('data-cosmo-checkout-row');
      currentRow = row;
      row?.setAttribute('data-cosmo-checkout-row', '');
    }
    const rect = button?.getBoundingClientRect();
    const active = Boolean(rect && rect.width > 0 && rect.height > 0 && rect.top > 0 && rect.top < window.innerHeight);
    root.toggleAttribute('data-cosmo-cart-chat', active && Boolean(scope));
    root.toggleAttribute('data-cosmo-purchase-chat', active && Boolean(sticky));
    if (active) {
      const chat = activator(document.querySelector('shopify-chat')?.shadowRoot);
      if (chat) {
        chatRetries = 0;
        const chatRect = chat.getBoundingClientRect();
        offsetY += rect.top - 12 - chatRect.bottom;
        offsetX += rect.right - chatRect.right;
        root.style.setProperty('--cosmo-chat-x', offsetX + 'px');
        root.style.setProperty('--cosmo-chat-y', offsetY + 'px');
      } else if (chatRetries++ < 10) {
        setTimeout(schedule, 200);
      }
    } else {
      offsetX = offsetY = 0;
      chatRetries = 0;
      root.style.removeProperty('--cosmo-chat-x');
      root.style.removeProperty('--cosmo-chat-y');
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const start = () => {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('transitionend', schedule);
    document.fonts?.ready.then(schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();